var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	6251: {
		fallback: ()=>()=>{throw new Error("Can not get '@agendrix/design-system'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@agendrix/design-system",

	},
	3697: {
		fallback: ()=>()=>{throw new Error("Can not get '@apollo/client'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@apollo/client",

	},
	5836: {
		fallback: ()=>()=>{throw new Error("Can not get '@azure/msal-browser'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@azure/msal-browser",

	},
	347: {
		fallback: ()=>()=>{throw new Error("Can not get '@azure/msal-react'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@azure/msal-react",

	},
	36: {
		fallback: ()=>()=>{throw new Error("Can not get 'history'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "history",

	},
	2727: {
		fallback: ()=>()=>{throw new Error("Can not get 'i18next'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "i18next",

	},
	198: {
		fallback: ()=>()=>{throw new Error("Can not get '@microsoft/applicationinsights-react-js'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@microsoft/applicationinsights-react-js",

	},
	7037: {
		fallback: ()=>()=>{throw new Error("Can not get '@microsoft/applicationinsights-web'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@microsoft/applicationinsights-web",

	},
	3362: {
		fallback: ()=>()=>{throw new Error("Can not get 'react-dom'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	1156: {
		fallback: ()=>()=>{throw new Error("Can not get 'react-redux'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-redux",

	},
	8551: {
		fallback: ()=>()=>{throw new Error("Can not get 'react'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	1286: {
		fallback: ()=>()=>{throw new Error("Can not get '@reduxjs/toolkit'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@reduxjs/toolkit",

	},
	8098: {
		fallback: ()=>()=>{throw new Error("Can not get '@unity/auth-lib'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@unity/auth-lib",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"272": [
		6251,
		3697,
		5836,
		347,
		36,
		2727,
		198,
		7037,
		3362,
		1156,
		8551,
		1286,
		8098
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}